import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Img } from 'react-image';
import { PaddedContainer } from '../common/styles';
import dt, { useIsXXLarge } from '../../../shared/theme';

const heroPortraitAspectRatio = 774 / 992;
const heroWidthMobile = 100;
const heroHeightDesktop = 571;
const heroHeightMobile = heroWidthMobile / heroPortraitAspectRatio;

const Top = styled.div`
  margin-top: ${props => (props.theme.isMobile ? '0' : '-70px')};
  height: unset;
  width: 100vw;
  background: linear-gradient(to right, white 70% , ${props => props.theme.secondaryColorLight} 70%);

  ${props => (props.theme.isMobile && `
    height: ${heroHeightMobile}vw;
  `)};

  ${props => dt(props).theme.isLarge && `
    height: ${heroHeightDesktop}px;
  `};

  > div {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: right;
  }
`;
const Container = styled(PaddedContainer)`
  position: relative;
  top: 0;
  display: flex;
  flex-direction: column;
  height: ${props => (props.theme.isMobile ? `${heroHeightMobile}vw` : `${heroHeightDesktop}px`)};
  z-index: 150;
  justify-content: start;
`;

const Desc = styled.p`
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  color: ${props => props.theme.bodyColor};
  ${props => (props.theme.isMobile ? `
    margin-top: 67px;
    width: 100%;
    font-size: 35px;
    line-height: 46px;
  ` : `
    margin: 200px 0 36px 0;
    width: 604px;
    font-size: 44px;
    line-height: 56px;
  `)};
`;

// The round corner on the bottom right is not exactly a circle corner.
// The area is out of the view width by 44px on the 1440px design.
const Bottom = styled.div`
  width: unset;
  border-bottom-right-radius: 200px;
  display: flex;
  justify-content: center;
  position: relative;
  top: -1px;
  background-color: ${props => props.theme.secondaryColorLight};
  padding-top: 20px;
  ${props => (props.theme.isMobile ? `
    padding: 32px 0 110px 0;
    width: calc(100vw + 44px);
    margin-left: -22px;
  ` : `
    flex-wrap: wrap;
  `)};

  ${props => dt(props).theme.isLarge && `
    margin-left: -22px;
    padding: 40px 44px 50px 0;
  `};

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;

    > div {
      display: flex;
      flex-direction: column;

      ${props => dt(props).theme.isXLarge && `
        flex-direction: row;
      `};
    }
  }  
`;

const Title = styled.span`
  text-align: center;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 20px;
  text-transform: uppercase;
  line-height: 20px;
  margin-bottom: ${props => (props.theme.isMobile ? 37 : 28)}px;
`;

const Media = styled(Img)`
  width: 150px;
  height: 44px;
`;

const Space = styled.span`
  display: block;
  height: ${props => (props.theme.isMobile ? 55 : 44)}px;
  max-width: 86px;
  width: 6vw;
`;

export default function Hero() {
  const {
    hero, heroPortrait, media,
  } = React.useContext(ThemeContext);

  const isXXLarge = useIsXXLarge();

  return (
    <React.Fragment>
      <Top>
        <div style={{ backgroundImage: `url(${isXXLarge ? hero : heroPortrait})` }}>
          <Container>
            <Desc>
              Make confident investment decisions through leading market insights and analysis
            </Desc>
          </Container>
        </div>
      </Top>
      <Bottom>
        <div>
          <Title>as seen in</Title>
          <div>
            {media.map((m, i) => (
              <React.Fragment key={m}>
                {!!i && <Space />}
                <Media src={m} />
              </React.Fragment>
            ))}
          </div>
        </div>
      </Bottom>
    </React.Fragment>
  );
}
